export default "__VITE_ASSET__C_kzm8_a__"